import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService } from '@spartacus/core';
import { of, Subscription } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { BaseService } from 'src/app/shared/services/base.service';
import * as _ from 'underscore';
import * as config from '../../../app/shared/config/app.config';
import { CustomerHierarchyService } from '../customer-hierarchy.service';

@Component({
  selector: 'app-assign-customers',
  templateUrl: './assign-customers.component.html',
  styleUrls: ['./assign-customers.component.scss'],
})
export class AssignCustomersComponent implements OnInit, OnDestroy {
  @Input() parentNode: string;
  tabSelected: any;
  baseSiteId: any;
  numberSearchList: any = [];
  numberCheckedList: any = [];
  numberEnable: boolean;
  numberPastedText: string;
  searchText: string = '';
  searchCustomerList: any = [];
  searchCheckedList: any = [];
  b2bUnit: any;
  addSubmit: boolean;
  baseSub: Subscription;
  baseSiteSub: Subscription;
  serviceSub: Subscription;
  addCustSub: Subscription;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly baseSiteService: BaseSiteService,
    private readonly serviceClass: CustomerHierarchyService,
    private readonly baseService: BaseService
  ) {}

  ngOnInit(): void {
    this.baseSub = this.baseService
      .get(config.GET_ACCOUNT_ID)
      .subscribe((res) => {
        this.b2bUnit = res?.defaultB2BUnit?.uid;
        this.searchCustomer();
      });
    this.baseSiteSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.tabNavigation('Numbers');
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.baseSiteSub?.unsubscribe();
    this.serviceSub?.unsubscribe();
    this.addCustSub?.unsubscribe();
  }
  tabNavigation(id): void {
    const idArray = ['Numbers', 'Search'];
    this.tabSelected = id;
    for (const item of idArray) {
      if (id === item) {
        document.getElementById(item).style.display = 'block';
      } else {
        document.getElementById(item).style.display = 'none';
      }
    }
    this.cdr.detectChanges();
  }
  cancelPopup() {
    this.modalService.dismissAll();
  }
  numberSearchCustomer(event: ClipboardEvent) {
    this.numberEnable = false;
    let clipboardData = event.clipboardData;
    this.numberPastedText = clipboardData.getData('text');
    const formattedString = clipboardData.getData('text').replace(/\s+/gm, ' ');
    let params = {
      customerUnit: this.b2bUnit,
      searchText: formattedString,
    };
    this.serviceSub = this.serviceClass.getValidCustomers(params).subscribe(
      (res) => {
        if (res?.customers) {
          this.numberSearchList = _.uniq(res?.customers, (el) => el.uid);
          this.numberSearchList.map((item) => (item.isSelected = true));
          this.getNumberCheckedItemList();
        }
        this.numberEnable = true;
      },
      (errors) => {
        this.numberEnable = true;
      }
    );
  }
  searchCustomer() {
    of(this.searchText)
      .pipe(
        switchMap((val) =>
          this.serviceClass.getSearchCustomers({
            customerUnit: this.b2bUnit,
            searchText: val,
          })
        )
      )
      .subscribe((res) => {
        this.searchCustomerList = [];
        if (res?.customers?.length > 0) {
          this.searchCustomerList = _.uniq(res?.customers, (el) => el.uid);
          this.searchCustomerList.map((item) => (item.isSelected = false));
        }
        this.cdr.detectChanges();
      });
  }
  getNumberCheckedItemList() {
    this.numberCheckedList = [];
    this.numberSearchList.forEach((element) => {
      if (element.isSelected) {
        this.numberCheckedList.push(element);
      }
    });
  }
  getSearchCheckedItemList() {
    this.searchCheckedList = [];
    this.searchCustomerList.forEach((element) => {
      if (element.isSelected) {
        this.searchCheckedList.push(element);
      }
    });
  }
  addCustomer() {
    this.addSubmit = true;
    let addValue =
      this.tabSelected == 'Numbers'
        ? this.numberCheckedList
        : this.searchCheckedList;
    let params = {
      customerUnit: this.b2bUnit,
      nodeId: this.parentNode,
      selectedCustomers: addValue?.map((item) => item.uid),
    };
    this.addCustSub = this.serviceClass.addCustomer(params).subscribe(
      (res) => {
        this.addSubmit = false;
        this.modalService.dismissAll('success');
      },
      (errors) => {
        this.addSubmit = false;
        this.modalService.dismissAll();
      }
    );
  }
}
